/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

// --- Imports from your project structure ---
import {
  Container,
  InputContainer,
  StyledInputV2,
  StyledLabel,
  ButtonContainer,
} from '../CreateEvent/style';
import { FormHeading } from '../ChallengeCreationAdmin/ActivityChallengeLaunch/style';
import { Main } from '../AdminTeamCreation/styles';
import { Layout } from '../EditWellnessJourney/styles';
import { Border } from '../Journeys/styles';
import { ManagerIconContainer } from '../Manager/styles';
import { CommonButtonPopup } from '../ReportsV2/styles';
import { CommonButtonBorder } from '../common/commonStyles';
import { ImageUrl } from '../../utils/constants';
import CommonImageUploader from '../common/CommonImageUploader/CommonImageUploader';
import CommonDropdown from '../common/CommonDropDown/CommonDropdown';
import { fetchApi, getMonthName } from '../../utils/methods';
import { GetWellnessGoals, GetQuestionByCategoryId, EditVideoByCategory, GetWellbeingPillars, GetFitnessVideoById } from '../../redux/constants/apiConstants';
import { RecognitionCloseIcon, UploadIcon, closeIcon } from '../../utils/icons';
import { t } from 'i18next';

// --- Styled Components ---

const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px;
  border: 1px solid #BDBDBD;
  border-radius: 4px;
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  color: #184A61;
  resize: vertical;
  outline: none;
  background: white;
  &::placeholder { color: #BDBDBD; }
`;

const CategoryGrid = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
`;

const CategoryChip = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 15px;
  border: 1px solid ${(props) => (props.active ? '#DA6C74' : '#E0E0E0')};
  background-color: ${(props) => (props.active ? '#DA6C74' : '#FFFFFF')};
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 100px;

  &:hover {
    border-color: #DA6C74;
  }
`;

const CategoryText = styled.span`
  font-size: 14px;
  font-weight: ${(props) => (props.active ? '500' : '400')};
  color: ${(props) => (props.active ? '#fff' : '#184A61')};
  display: flex;
  align-items: center;

  img{
    background: ${(props) => (props.active ? '#fff' : '#fff')};
  };
`;

const UrlValidationMessage = styled.div`
  color: ${(props) => (props.isValid ? '#4CAF50' : '#F44336')};
  font-size: 12px;
  margin-top: 4px;
  font-family: 'Lato', sans-serif;
`;

const StepCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? '#092F41' : '#F8F8F8')}; 
  /* Active: White (#FEFEFE)
     Completed: Dark Blue (#184A61)
     Incomplete: Grey (#BDBDBD) 
  */
  color: ${(props) => {
    if (props.active) return '#FEFEFE';
    if (props.completed) return '#184A61';
    return '#BDBDBD';
  }};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
`;

const StepText = styled.div`
  /* Active or Completed: Dark Blue (#184A61)
     Incomplete: Grey (#BDBDBD) 
  */
  color: ${(props) => (props.active || props.completed ? '#184A61' : '#BDBDBD')};
  font-weight: ${(props) => (props.active ? '700' : '700')};
  font-size: 18px;
  font-Family: 'Lato';
`;

class EditFitnessvideoForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.state,
      description: props.state.description || "",
      step: 1,
      wellnessGoals: [],
      wbaQuestions: [],
      showWbaQue: false,
      isLoadingQuestions: false,
      urlValid: true,
      charCount: props.state.description ? props.state.description.length : 0,
      themeOpen: false,
      goalOpen: false,
      questionOpen: false,
      muscleGroupOpen: false,
      fitnessLevelOpen: false,
      video_categories: props.state.video_categories || [],
      fitnessVideoDetailsById:null,
      isDisabled:false
    };
  }

  componentDidMount() {
    const { match } = this.props;
    // this.getWellnessGoals();
    this.fetchFitnessVideoeDetails(match?.params?.id);
    if (this.state.video_url) {
      this.validateUrl(this.state.video_url);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.state !== prevProps.state) {
      this.setState({ 
        ...this.props.state,
        video_categories: this.props.state.video_categories || [],
        charCount: this.props.state.description ? this.props.state.description.length : 0
      }, () => {
        if(this.state.video_url) this.validateUrl(this.state.video_url);
        if (this.state.selectedWellnessGoal) {
          this.getWBAQuestions(this.state.selectedWellnessGoal);
        }
      });
    }
  }

  fetchFitnessVideoeDetails = async(id)=>{
    let apiUrl = GetFitnessVideoById + "/" + id;
    try {
      const res = await fetchApi(apiUrl , "GET");
      if (res.status === "success") {
        this.setState({fitnessVideoDetailsById: res?.data?.[0]?.video_details},()=>{this.getAllWellbeingPillars();this.setEditData(this.state.fitnessVideoDetailsById)})

      } else {
        toast.error(res?.data?.message || res.data?.[0]);

        window.setTimeout(() => {
          if(res?.data?.code === 422){
            this.props?.history?.goBack();
          }
        }, 3000);
      }
    } catch (error) {
      window.console.error(error);
    }

  }

  getAllWellbeingPillars = async () => {
    // setIsLoading(true);
    try {
      const res = await fetchApi(GetWellbeingPillars , "GET");

      if (res.status === "success") {
        // setWellbeingPillars(res.data);
        this.setState({wellbeingPillars:res?.data},()=>this.populateMonthlyTheme())
        // setIsLoading(false);
      } else {
        toast.error(res.data.message || "Something went wrong");
        // setIsLoading(false);s

      }
    } catch (error) {
      window.console.error(error);
      // setIsLoading(false);
    }
  };

  populateMonthlyTheme = () => {
    const { fitnessVideoDetailsById } = this.state;
    if (!fitnessVideoDetailsById.month) return;
  
    const selectedWellbeingPillar = this.state.wellbeingPillars.find(
      (item) => item.id === fitnessVideoDetailsById.month
    );
  
    this.setState({ selectedWellbeingPillar });
  };


  setEditData = (responseData) => {
    const { muscle_group, fitness_level } = this.props;
    let newEditState = { };

    // Handle nested API structure
    const editFitnessData = responseData; 

    if (editFitnessData) {
      newEditState.title = editFitnessData.title || editFitnessData.video_title;
      newEditState.description = editFitnessData.description || "";
      newEditState.video_category_id = editFitnessData.wellness_category_id;
      newEditState.video_categories = this.setCategoryId(editFitnessData.video_categories);
      newEditState.video_url = editFitnessData.video_url;
      newEditState.themeId = editFitnessData.theme_id;
      newEditState.imgSrc = editFitnessData?.thumbnail_image;

      const muscleData = [
        { id: "none", category_name: t("None") },
        ...(muscle_group || []).filter((m) => m.id !== "none")
      ];
  
      const fitnessData = [
        { id: "none", category_name: t("None") },
        ...(fitness_level || []).filter((f) => f.id !== "none")
      ];

      const selectedMuscleGroup = muscleData.find(
        (item) => item.category_name === responseData?.muscle_group
      );
      
      const selectedFitnessLevel = fitnessData.find(
        (item) => item.category_name === responseData?.fitness_level
      );


      this.onSelectMuscleGroup(selectedMuscleGroup || { id: "none", category_name: t("None") });
      this.onSelectFitnessLevel(selectedFitnessLevel || { id: "none", category_name: t("None") })


      newEditState.selectedWellnessGoal = editFitnessData?.wellness_goal_id;
      newEditState.selectedQuestionId = editFitnessData.question_id;
      newEditState.showWbaQue = editFitnessData?.wellness_goal_id && true
      if(editFitnessData.wellness_goal_id){this.getWBAQuestions(editFitnessData.wellness_goal_id)}
      this.getWellnessGoals();
    }


    this.setState({ ...newEditState });
  }

  setCategoryId = (categoryTags) => {
    let arr = [];
    if (categoryTags && Array.isArray(categoryTags)) {
      categoryTags?.forEach((data) => {
        if(data && data.id) arr.push(data.id);
      });
    }
    return arr;
  };

  // --- API Methods ---

  getWellnessGoals = async () => {
    try {
      const res = await fetchApi(`${GetWellnessGoals}`, "GET", null, {});
      if (res && res.data) {
        const selectedWellnessGoal = res.data.find(
          (item) => item.id === this.state.fitnessVideoDetailsById?.wellness_goal_id
        );
        this.setState({ wellnessGoals: res.data, selectedWellnessGoal: selectedWellnessGoal});
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  getWBAQuestions = async (categoryId) => {
    this.setState({ isLoadingQuestions: true });
    try {
      const res = await fetchApi(`${GetQuestionByCategoryId + "/" + categoryId}`, "GET", null, {});
      if (res && res.data && res.data.length > 0) {
        const formattedQuestions = res.data.map((item) => ({
          ...item,
          displayLabel: item.question || item.question_text || `Question ${item.id}`,
        }));
        this.setState({ wbaQuestions: formattedQuestions, showWbaQue: true });
      } else {
        this.setState({ wbaQuestions: [], showWbaQue: false });
      }
    } catch (error) {
      window.console.error(error);
    } finally {
      this.setState({ isLoadingQuestions: false });
    }
  }

  // --- Input Handlers ---

  onChangeInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });

    if (name === 'description') {
      this.setState({ charCount: value ? value.length : 0 });
    }
    if (name === 'video_url') {
      this.validateUrl(value);
    }
  };

  validateUrl = (url) => {
    const pattern = /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)$/;
    const isValid = url ? pattern.test(url) : false;
    this.setState({ urlValid: isValid });
    return isValid;
  };

  handleImageChange = (imgSrc) => {
    this.setState({ imgSrc: imgSrc });
  };

  handleRemoveImage = () => {
    this.setState({ imgSrc: "" });
  };

  toggleCategory = (id) => {
    const { video_categories } = this.state;
    let newIds = [...(video_categories || [])];

    if (newIds.includes(id)) {
      newIds = newIds.filter((item) => item !== id);
    } else {
      newIds.push(id);
    }
    this.setState({ video_categories: newIds });
  };

  toggleDropdown = (stateKey) => {
    const keys = ['muscleGroupOpen', 'fitnessLevelOpen', 'themeOpen', 'goalOpen', 'questionOpen'];
    const newState = {};
    keys.forEach((k) => { newState[k] = (k === stateKey) ? !this.state[k] : false; });
    this.setState(newState);
  };

  onSelectMuscleGroup = (item) => this.setState({ muscle_group: item.id, muscleGroupOpen: false,selectedMuscleGroup:item });

  onSelectFitnessLevel = (item) => this.setState({ fitness_level: item.id, fitnessLevelOpen: false,selectedFitnessLevel:item });

  onSelectTheme = (item) => {
    this.setState({selectedWellbeingPillar:item});
  };

  onSelectGoal = (item) => {
    if (item.id === null) {
      this.setState({ selectedWellnessGoal: null, goalOpen: false, showWbaQue: false, selectedQuestionId: null });
      return;
    }
    this.setState({ selectedWellnessGoal: item, goalOpen: false, selectedQuestionId: null }, () => {
      this.getWBAQuestions(item.id);
    });
  };

  onSelectQuestion = (item) => this.setState({ selectedQuestionId: item.id, questionOpen: false });

  isStepValid = () => {
    const { step, title, imgSrc, video_url, description, video_categories, urlValid } = this.state;

    if (step === 1) {
      const safeDesc = description || "";
      return (
        title && title.trim() !== '' &&
        imgSrc &&
        video_url && video_url.trim() !== '' && urlValid &&
        safeDesc && safeDesc.trim() !== ''
      );
    }
    if (step === 2) {
      return video_categories && video_categories.length > 0;
    }
    return false;
  };

  nextStep = () => {
    if (this.isStepValid()) {
      this.setState((prev) => ({ step: prev.step + 1 }));
      window.scrollTo(0, 0);
    } else {
      toast.error(this.props.t('Please fill all mandatory fields correctly'));
    }
  };

  prevStep = () => {
    this.setState((prev) => ({ step: prev.step - 1 }));
    window.scrollTo(0, 0);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.isStepValid()) {
      // Trigger parent's onSubmit
      // this.props.onSubmit(e, this.state);
      const{description, title,thumbnail_image,video_url,video_categories,selectedWellbeingPillar,selectedWellnessGoal,/*question,level,*/imgSrc,selectedMuscleGroup,selectedFitnessLevel,selectedQuestionId, fitnessVideoDetailsById}= this.state;
      const payload = {
        month:selectedWellbeingPillar?.id,
        description, 
        title,
        thumbnail_image:thumbnail_image || imgSrc,video_url,
        video_categories:video_categories,
        wellness_goal_id:selectedWellnessGoal?.id,
        question_id:selectedQuestionId,
        // levels:level.level,
        fitness_level:selectedFitnessLevel?.category_name,
        muscle_group:selectedMuscleGroup?.category_name,
        id:fitnessVideoDetailsById?.id
      }
      this.editFitnessVideo(payload);
    } else {
      toast.error(this.props.t('Please check all fields'));
    }
  }

  editFitnessVideo = async (payload) => {
    window.console.log("Edit Fitness Videos")
    this.setState({ isDisabled: true }); 
    try {
      const res = await fetchApi("/" + EditVideoByCategory , "PUT",payload);
      if (res.status === "success") {
        this.props.history.push(`/wellness-resources`);
      } else {
        toast.error(res.data.message || "Something went wrong");
      }
    } catch (error) {
      window.console.error(error);
    }finally{
      this.setState({ isDisabled: false }); 
    }
  };

  checkBase64(image) {
    if (image) {
      if (image.startsWith('data:image')) return true;
      if (image.includes('video-category-image')) return false;
      return true; 
    }
    return false;
  }

  // --- Render Helpers ---

  renderStepOne = () => {
    const { t } = this.props;
    const { title, video_url, description, charCount, imgSrc, urlValid } = this.state;
    const displayDescription = description || "";

    let displayImage = "";
    if (imgSrc) {
      displayImage = this.checkBase64(imgSrc) ? imgSrc : `${ImageUrl}/${imgSrc}`;
    }

    return (
      <div className="formBody">
        <InputContainer>
          <StyledLabel isFont="16px" color="#184A61" margin="0px" symbolSize="16px">
            {t('Fitness Video Title')}<span>*</span>
          </StyledLabel>
          <StyledInputV2
            placeholder={t('Enter fitness video title')}
            name="title"
            onChange={this.onChangeInput}
            value={title}
            maxLength="100"
            border="0.75px solid #BDBDBD"
          />
          <div className="count">{title ? title.length : 0}/100 | C</div>
        </InputContainer>

        <Border style={{ background: '#EFEFEF', margin: '16px 0' }} />

        <StyledLabel isFont="16px" color="#184A61" margin="0px 0px 12px 0px" symbolSize="16px">
          {t('Fitness video Thumbnail')}<span>*</span>
        </StyledLabel>
        <CommonImageUploader
          imgSrc={displayImage}
          t={t}
          closeIcon={closeIcon}
          UploadIcon={UploadIcon}
          onImageChange={this.handleImageChange}
          onRemoveImage={this.handleRemoveImage}
        />

        <Border style={{ background: '#EFEFEF', margin: '20px 0' }} />

        <InputContainer>
          <StyledLabel isFont="16px" color="#184A61" margin="0px" symbolSize="16px">
            {t('Fitness Video UR')}<span>*</span>
          </StyledLabel>
          <StyledInputV2
            placeholder={t('Enter fitness video URL')}
            name="video_url"
            onChange={this.onChangeInput}
            value={video_url}
            border={`0.75px solid ${urlValid ? '#BDBDBD' : '#F44336'}`}
          />
          {!urlValid && video_url && (
            <UrlValidationMessage isValid={false}>{t('Invalid URL format')}</UrlValidationMessage>
          )}
        </InputContainer>

        <Border style={{ background: '#EFEFEF', margin: '20px 0' }} />

        <InputContainer isColorError={charCount > 3000}>
          <StyledLabel isFont="16px" color="#184A61" margin="0px" symbolSize="16px">
            {t('Fitness video Description')}<span>*</span>
          </StyledLabel>
          <StyledTextArea
            name="description"
            placeholder={t('Write your fitness video description here')}
            value={displayDescription}
            onChange={this.onChangeInput}
            maxLength={3000}
          />
          <div className="count">{charCount}/3000 | C</div>
        </InputContainer>
      </div>
    );
  };

  renderStepTwo = () => {
    const { t, video_category_id,  muscle_group, fitness_level,/*themesHeaderAll*/ } = this.props;
    const {
      video_categories,
      // muscle_group: selectedMuscle,
      // fitness_level: selectedFitness,
      // themeId,
      // themeName,
      // themeMonth,
      selectedWellnessGoal,
      selectedQuestionId,
      wellnessGoals, wbaQuestions, showWbaQue,
      muscleGroupOpen, fitnessLevelOpen, themeOpen, goalOpen, questionOpen, isLoadingQuestions,
      wellbeingPillars,
      selectedWellbeingPillar,
      selectedMuscleGroup,
      selectedFitnessLevel,
    } = this.state;

    const muscleData = [
      { id: "none", category_name: t("None") },
      ...(muscle_group || []).filter((m) => m.id !== "none")
    ];

    const fitnessData = [
      { id: "none", category_name: t("None") },
      ...(fitness_level || []).filter((f) => f.id !== "none")
    ];

    // Sorting Logic for Monthly Themes
    // const monthOrder = {
    //   "January": 1, "February": 2, "March": 3, "April": 4, 
    //   "May": 5, "June": 6, "July": 7, "August": 8, 
    //   "September": 9, "October": 10, "November": 11, "December": 12
    // };

    // let sortedThemes = [];
    // if (themesHeaderAll && themesHeaderAll.length > 0) {
    //   sortedThemes = [...themesHeaderAll].sort((a, b) => {
    //     const monthA = a.month ? monthOrder[a.month] || 99 : 99;
    //     const monthB = b.month ? monthOrder[b.month] || 99 : 99;
    //     return monthA - monthB;
    //   });
    // }

    // const themeOptions = sortedThemes.length > 0
    //   ? [{ id: null, theme_text: "None", displayLabel: t("None") }, ...sortedThemes.map((theme) => ({
    //     ...theme,
    //     displayLabel: theme.month ? `${theme.month}, ${theme.theme_text}` : theme.theme_text
    //   }))]
    //   : [{ id: null, theme_text: "", displayLabel: t("No Themes Available") }];

    const goalData = [{ id: null, name: t("None") }, ...(wellnessGoals || [])];

    const questionData = (wbaQuestions || []).map((q) => ({ ...q, displayLabel: q.question || q.question_text }));

    // const selectedGoalObj = (wellnessGoals || []).find((g) => g.id === selectedWellnessGoal);
    const selectedQuestionObj = (wbaQuestions || []).find((q) => q.id === selectedQuestionId);

    // let themeTitle = t("None");
    // if (themeName && themeMonth) themeTitle = `${themeMonth}, ${themeName}`;
    // else if (themeName) themeTitle = themeName;

    return (
      <div className="formBody">
        <StyledLabel isFont="16px" color="#184A61" margin="0px 0px 12px 0px" symbolSize="16px">
          {t('Select Category')} <span>*</span>
        </StyledLabel>

        <CategoryGrid>
          {video_category_id && video_category_id.length > 0 ? (
            video_category_id.map((cat) => (
              <CategoryChip
                key={cat.id}
                active={video_categories && video_categories.includes(cat.id)}
                onClick={() => this.toggleCategory(cat.id)}
              >
                <CategoryText active={video_categories && video_categories.includes(cat.id)}>
                  {cat.image && <img src={ImageUrl + "/" + cat.image} alt="" style={{ width: 18, height: 18, marginRight: 8, borderRadius: '50%' }} />}
                  <span style={{fontSize:'16px'}}>{cat.category_name}</span>
                </CategoryText>
              </CategoryChip>
            ))
          ) : (
            <div>{t('No categories available')}</div>
          )}
        </CategoryGrid>

        <Border style={{ background: '#EFEFEF', margin: '10px 0' }} />

        <div style={{ display: 'flex', gap: '20px', flexDirection: 'row' }}>
          <div style={{ flex: 1, position: 'relative' }}>
            <CommonDropdown
              tileContainerStyle={{ width: '100%' }}
              labelText={t("Muscles Focus")}
              dropdownOpen={muscleGroupOpen}
              title={selectedMuscleGroup?.category_name || t('None')}
              onClick={() => this.toggleDropdown('muscleGroupOpen')}
              data={muscleData}
              onSelect={this.onSelectMuscleGroup}
              active={selectedMuscleGroup?.id}
              onSelectParameter={['category_name']}
              itemValue valueIndex={0} valueString=""
              noBorder
              dropIcon
              labelMargin={"0px"}
              margin={'0px'}
            />
          </div>

          <div style={{ flex: 1, position: 'relative' }}>
            <CommonDropdown
              tileContainerStyle={{ width: '100%' }}
              labelText={t("Fitness Level")}
              dropdownOpen={fitnessLevelOpen}
              title={selectedFitnessLevel?.category_name || t('None')}
              onClick={() => this.toggleDropdown('fitnessLevelOpen')}
              data={fitnessData}
              onSelect={this.onSelectFitnessLevel}
              active={selectedFitnessLevel.id}
              onSelectParameter={['category_name']}
              itemValue
              valueIndex={0}
              valueString=""
              noBorder
              dropIcon
              labelMargin={"0px"}
              margin={'0px'}
            />
          </div>
        </div>

        <Border style={{ background: '#EFEFEF', margin: '20px 0 20px' }} />

        <div style={{ position: 'relative'}}>
          <CommonDropdown
            tileContainerStyle={{ width: "100%", padding: "0px 0px 12px 0px" }}
            dropdownStyle={{ top: "90px" }}
            labelText={t("Monthly Theme")}
            dropdownOpen={themeOpen}
            placeholder={t("None)")}
            // title={themeTitle}
            title={(selectedWellbeingPillar?.pillar_title) ? ` ${getMonthName(selectedWellbeingPillar?.id) + " - " + selectedWellbeingPillar?.pillar_title}` : t('Select theme')}
            id="dropdown-monthly-theme"
            onClick={() => this.toggleDropdown('themeOpen')}
            data={wellbeingPillars}
            onSelect={this.onSelectTheme}
            // active={themeId}
            onSelectParameter={['pillar_title','id']}
            valueString={""}
            itemValue={true}
            valueIndex={0}
            dropIcon={true}
            labelMargin={"0px"}
            fontSize={"16px"}
            margin={'0px'}
            showMonthName={true}
          />
        </div>

        <div style={{ position: 'relative' }}>
          <CommonDropdown
            tileContainerStyle={{ width: '100%' }}
            labelText={t("Wellness Goal")}
            dropdownOpen={goalOpen}
            title={selectedWellnessGoal?.name || t('None')}
            onClick={() => this.toggleDropdown('goalOpen')}
            data={goalData}
            onSelect={this.onSelectGoal}
            active={selectedWellnessGoal}
            onSelectParameter={['name']}
            margin={'0px'}
            itemValue valueIndex={0} valueString="" noBorder dropIcon
            labelMargin={"0px"}
          />
        </div>

        {showWbaQue && (
          <div style={{ position: 'relative', marginTop: '20px' }}>
            <CommonDropdown
              tileContainerStyle={{ width: '100%' }}
              labelText={t("Question (WBA)")}
              dropdownOpen={questionOpen}
              title={selectedQuestionObj ? (selectedQuestionObj.displayLabel) : t('Select Question')}
              onClick={() => this.toggleDropdown('questionOpen')}
              data={questionData}
              onSelect={this.onSelectQuestion}
              active={selectedQuestionId}
              onSelectParameter={['displayLabel']}
              labelMargin={"0px"}
              margin={'0px'}
              itemValue valueIndex={0} valueString="" noBorder dropIcon isLoading={isLoadingQuestions}
            />
          </div>
        )}
      </div>
    );
  };


  redirect = () => {
    const page = this.props.location?.state?.page;
  
    if (page === "Fitness" ) {
      this.props.history.push(
        "/company/wellness",
        { activeTab: "Library", activeLibraryTab: "Fitness" }
      );
    } else {
      this.props.history.goBack();
    }
  };

  render() {
    const { step,isDisabled } = this.state;
    const { buttonText, t,/* history */} = this.props;
    const isValid = this.isStepValid();

    return (
      <Layout>
        <div className="main" style={{marginTop:'-70px'}}>
          <FormHeading color="#184A61">
            <div className="close-icon" onClick={this.redirect}>
              <ManagerIconContainer isWidth="32px">{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
            </div>
            {t('Edit Fitness Videos')}
          </FormHeading>

          <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>
            <div className="stepsNameHighlight">
              <div style={{ padding: "20px 20px", width: '100%', background: '#fff',borderRadius:'12px' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                  
                  {/* Step 1 Indicator */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <StepCircle active={step === 1} completed={step > 1}>1</StepCircle>
                    <StepText active={step === 1} completed={step > 1}>{t('About Fitness')}</StepText>
                  </div>

                  <div  style={{ border: '0.75px solid #efefef', width: '100%' }}></div>
                  
                  {/* Step 2 Indicator */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <StepCircle active={step === 2}>2</StepCircle>
                    <StepText active={step === 2}>{t('Customize Fitness')}</StepText>
                  </div>

                </div>
              </div>
            </div>

            <div className="form">
              <form onSubmit={this.handleSubmit}>
                {step === 1 && this.renderStepOne()}
                {step === 2 && this.renderStepTwo()}
              </form>
            </div>
          </Container>

          <ButtonContainer style={{ width: '100%', left: '0' }}>
            <Main>
              <div className="wrapper" style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', gap: '15px' }}>
                {step > 1 && (
                  <CommonButtonBorder width="200px" height="48px" onClick={this.prevStep} style={{ position: 'absolute', left: '125px' }}>
                    {t('Back')}
                  </CommonButtonBorder>
                )}

                {step === 1 ? (
                  <CommonButtonPopup
                    height="48px" width="200px"
                    onClick={this.nextStep}
                    disabled={!isValid}
                    style={{
                      backgroundColor: isValid ? '#DA6C74' : '#EFEFEF',
                      color: isValid ? '#FFF' : '#666',
                      cursor: isValid ? 'pointer' : 'not-allowed'
                    }}
                  >
                    {t('Next')}
                  </CommonButtonPopup>
                ) : (
                  <CommonButtonPopup
                    height="48px" width="160px"
                    onClick={this.handleSubmit}
                    disabled={!isValid || isDisabled}
                    style={{
                      backgroundColor: isValid && !isDisabled ? '#DA6C74' : '#EFEFEF',
                      color: isValid && !isDisabled ? '#FFF' : '#666',
                      cursor: isValid && !isDisabled ? 'pointer' : 'not-allowed'
                    }}
                  >
                    {buttonText} <i className="fas fa-check" style={{ marginLeft: '8px' }}></i>
                  </CommonButtonPopup>
                )}
              </div>
            </Main>
          </ButtonContainer>
        </div>
      </Layout>
    );
  }
}

EditFitnessvideoForm.propTypes = {
  state: PropTypes.object.isRequired,
  buttonText: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  video_category_id: PropTypes.array,
  muscle_group: PropTypes.array,
  fitness_level: PropTypes.array,
  themesHeaderAll: PropTypes.array,
  location: PropTypes.object,
  t: PropTypes.func,
  history: PropTypes.object,
  match:PropTypes.object
};

export default withRouter(withTranslation()(EditFitnessvideoForm));